// iter269 — Android: read the Play Install Referrer once and turn the landing
// fbclid into the `_fbc` cookie so signup → CAPI carries the ad click.
import { Capacitor, registerPlugin } from '@capacitor/core';
import { writeFbcFromClick } from './metaPixel';
import { persistInstallUtm } from './utmCapture';
import { storeInviteCode } from './inviteCode';

const InstallReferrer = registerPlugin('InstallReferrer');
const DONE_KEY = 'rv_install_referrer_done';

export async function captureInstallReferrer() {
  if (Capacitor.getPlatform() !== 'android' || !Capacitor.isPluginAvailable('InstallReferrer')) return;
  try {
    if (localStorage.getItem(DONE_KEY)) return;
    const res = await Promise.race([
      InstallReferrer.getReferrer(),
      new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), 5000)),
    ]);
    localStorage.setItem(DONE_KEY, '1');
    const params = new URLSearchParams(res?.referrer || '');
    persistInstallUtm(params);
    storeInviteCode(params.get('ref'));
    const fbclid = params.get('fbclid');
    const clickMs = res?.clickTimestampSeconds ? res.clickTimestampSeconds * 1000 : Date.now();
    writeFbcFromClick(fbclid, clickMs);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[installReferrer] skipped:', e?.message);
  }
}
